<button
  type="button"
  class="btn btn-primary btn-sm rounded-3 d-inline-flex align-items-center gap-1 text-nowrap"
  aria-label="Open AI Campus VSI"
  title="AI Campus VSI"
  @click="$emit('open-assistant')"
>
  <i class="bi bi-robot fs-6"></i>
  <span class="d-none d-sm-inline text-xs">AI Campus VSI</span>
</button>
